import DesktopView from "./DesktopView";

export default DesktopView;
